export class Property {
  id: string;
  name: string;
  address: string;
  type: string;
  isActive: boolean;
  createdAt: number;
  operatorId: string;

  constructor(id = "", name = "", address = "", type = "", isActive = true) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.type = type;
    this.isActive = isActive;
    this.createdAt = Date.now();
    this.operatorId = "";
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/property/property.ts